module.exports = __webpack_public_path__ + "img/jushifulogo_blue.57016fd1.png";